import React from 'react';
import PropTypes from 'prop-types';

import {
  ProgressStep,
  ProgressSteps,
} from 'anf-core-react';

export default function ExchangeProgress({ steps, navigate, activeStep }) {
  let matched = false;

  return (
    <div className="exchange-progress">
      <ProgressSteps>
        {steps.map((step, idx) => {
          const match = activeStep === step;
          if (match) matched = true;

          return (
            <ProgressStep
              key={step.path}
              labelComplete={`Step ${idx + 1} of ${steps.length}, Complete`}
              labelInitial={`Step ${idx + 1} of ${steps.length}`}
              value={(idx + 1).toString()}
              isCurrentStep={!!match}
              isDisabled={!match && matched}
              onClick={() => navigate(step.path)}
            >
            &nbsp;
            </ProgressStep>
          );
        })}
      </ProgressSteps>
    </div>
  );
}

ExchangeProgress.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      finalize: PropTypes.bool,
    }),
  ).isRequired,
  navigate: PropTypes.func.isRequired,
  activeStep: PropTypes.shape({
    path: PropTypes.string,
    finalize: PropTypes.bool,
  }),
};

